import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment-timezone';
import ReactTable from 'react-table';
import "react-table/react-table.css";
import IconButton from 'material-ui/IconButton';
import { LocationActions } from '../../actions';
import TableDisplay from './TableDisplay';

export class OrdersList extends Component {
  static defaultProps = {
    multiSelectable: true,
    isAdmin: false,
    voidOrder: () => {},
    delivered: false,
  }
  static propTypes = {
    dataProvider: PropTypes.array.isRequired,
    voidOrder: PropTypes.func,
    onRowSelection: PropTypes.func,
    isAdmin: PropTypes.bool.isRequired,
    updateOrder: PropTypes.func,
    multiSelectable: PropTypes.bool,
    delivered: PropTypes.bool,
  }

  constructor(props) {
    super(props);

    this.onRowSelection = this.onRowSelection.bind(this);

    this.state = {
      open: false,
      selected: []
    };
  }

  componentWillMount() {
    const { locations } = this.props;

    if (!locations) {
      this.props.dispatch(LocationActions.getLocations());
    }
  }

  getLocation = (id) => {
    const { locations } = this.props;
    if (!locations || locations.fetching) {
      return id;
    }
    const item = _.find(locations.list, o => o.id === id);
    return (item && item.name) ? item.name : id;
  }

  getTrackingNumbers = (trackingNumbers) => {
    return trackingNumbers.map(item => `${item.trackingNumber} `);
  }

  onRowSelection(trackingNumber, isChecked) {
    const { selected } = this.state;
    if (isChecked) {
      selected.push(trackingNumber);
    } else {
      _.remove(selected, (itm) => itm === trackingNumber);
    }
    this.setState({ selected });
    this.props.onRowSelection(selected);
  }

  render() {
    const { voidOrder, dataProvider, delivered } = this.props;

    let columns = [
      {
        Cell: (d) => { return (<input type="checkbox" onChange={(v) => { this.onRowSelection(d.original.trackingNumber, v.currentTarget.checked) }} />) },
        width: 30
      },
      {
        Header: "Tracking Number",
        accessor: "trackingNumber"
      },
      {
        Header: "From",
        id: "from",
        accessor: d => _.get(d, 'order.from.name', '-')
      },
      {
        Header: "To",
        id: "to",
        accessor: d => _.get(d, 'order.to.name', '-')
      },
      {
        Header: "Pickup Time",
        id: "pickup",
        accessor: d => (d.pickup) ? moment(d.pickup.timestamp).tz('America/Chicago').format('llll') : '',
      },
      {
        Header: 'Status',
        id: "status",
        Cell: (d) => {
          if (_.get(d, 'original.status.id') === 1) {
            return <div><i className="material-icons" style={{verticalAlign: 'middle'}}>{_.get(d,'original.status.icon')}</i>{_.get(d,'original.status.name')}<IconButton iconClassName="material-icons" onClick={() => voidOrder(_.get(d, 'original.trackingNumber'))} style={{verticalAlign:'middle'}}>delete</IconButton></div>
          }
          return <div><i className="material-icons" style={{verticalAlign:'middle'}}>{_.get(d,'original.status.icon')}</i>{_.get(d,'original.status.name')}</div>;
        }
      }
    ];

    if (delivered) {
      const status = columns.pop();
      columns = _.concat(columns, [{
        Header: "Received By",
        id: "receiver",
        accessor: d => { return (d.delivery) ? d.delivery.receiver : null }
      },
      {
        Header: "Delivered At",
        id: "timestamp",
        accessor: d => { return (d.delivery) ? moment(d.delivery.timestamp).tz('America/Chicago').format('llll') : null }
      }]);
      columns.push(status);
    }

    return (
      <ReactTable
        data={dataProvider}
        columns={columns}
        defaultPageSize={10}
        className="-highlight"
        SubComponent={row => {
          return (
            <div style={{ padding: "20px" }}>
              <TableDisplay tracking={row.original} />
            </div>
          );
        }}
      />
    )
  }
}

const mapStateToProps = (state) => {
  const { orders, locations } = state;
  return {
    orders,
    locations
  }
}

 export default connect(mapStateToProps)(OrdersList);


// WEBPACK FOOTER //
// ./src/components/Orders/List.js